import React from 'react';
import { Dropdown } from 'react-bootstrap';
import PropTypes from 'prop-types';
import './_dropdown-menu.scss';
import styled from 'styled-components';

const CustomDropdown = ({
  dropdownToggle,
  dropdownMenu,
  toggleClassName,
  align,
  menuClassName,
  menuProps,
  dropDownProps,
  dropDownToggleProps,
  ...props
}) => {
  return (
    <StyledDropDown
      className={`custom-drop-down ${dropDownProps || ''}`}
      {...props}
    >
      <Dropdown.Toggle
        {...dropDownToggleProps}
        className={`menu-toggle  ${toggleClassName || ''}`}
      >
        {dropdownToggle}
      </Dropdown.Toggle>
      <Dropdown.Menu
        align={align || 'start'}
        className={`menu-dropdown ${menuClassName || ''}`}
        {...menuProps}
      >
        {dropdownMenu}
      </Dropdown.Menu>
    </StyledDropDown>
  );
};

export const StyledDropDown = styled(Dropdown)`
  .dropdown-toggle::before {
    display: none;
  }

  .dropdown-item {
    position: relative;
    &:hover,
    &.is-active {
      background-color: ${({ theme }) => `${theme.primary}`};

      &:before {
        content: '';
        position: absolute;
        display: block;
        width: 4px;
        border-top-right-radius: 10px;
        border-bottom-right-radius: 10px;
        left: 0;
        top: 10px;
        bottom: 10px;
        background-color: ${({ theme }) => `${theme.primary}`};
        margin-bottom: 0;
      }
    }

    &.active,
    &:active,
    &:hover {
      color: #ffffff;
      text-decoration: none;
      background-color: ${({ theme }) => theme.primary};
    }
  }
`;
CustomDropdown.propTypes = {
  dropdownToggle: PropTypes.element.isRequired,
  toggleClassName: PropTypes.string,
  dropdowwnMenu: PropTypes.element,
  menuClassName: PropTypes.string,
};
export default CustomDropdown;
